import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntIcon } from '../icon/icon.component.js';
import formGroupValidationStyles from './form-group-validation-message.css.js';

class CrntFormGroupValidationMessage extends CrntElement {
  static {
    /** @internal */
    this.dependencies = {
      [CrntIcon.tagName]: CrntIcon
    };
  }
  static {
    /** @internal */
    this.styles = trustedCSS(formGroupValidationStyles);
  }
  static {
    /** @internal */
    this.tagName = "crnt-form-group-validation-message";
  }
  /** @internal */
  #lightDomSlotFallbackController = new LightDomSlotFallbackController(this, [
    {
      fallbackElement: (() => {
        const icon = new CrntIcon();
        icon.icon = "triangle-exclamation";
        return icon;
      })(),
      slotName: "icon"
    }
  ]);
  connectedCallback() {
    super.connectedCallback();
    this.#lightDomSlotFallbackController.setFallbackSlotsContent();
  }
  render() {
    return html`<div class="crnt-form-group-validation-message" part="container">
			<slot @slotchange=${this.#handleSlotChange} name="icon"></slot>
			<slot @slotchange=${this.#handleSlotChange}></slot>
		</div>`;
  }
  #handleSlotChange() {
    this.#lightDomSlotFallbackController.setFallbackSlotsContent();
  }
}

export { CrntFormGroupValidationMessage };
